import { Button, Flex, Table, Tooltip } from "@mantine/core";
import { TagStatus } from "../../../../components";
import { InfoCircle } from "iconsax-react";
import { IResponseHistoryPlans } from "../../../../interfaces/MyPlans/IHistoryPlans";
import { postCancelHistoryPlans } from "../../../../hooks/useMyPlans";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotificationControl } from "../../../../context/notificationContext";
import { convertToDateAndHour } from "../../../../utils/date";
import { useTranslation } from "react-i18next";
import { colorStatusHistory } from "../../../../utils/StatusHistory";
import { EStatusHistory } from "../../../../interfaces/IQuery";
interface IProps {
  history: IResponseHistoryPlans;
  idProduct: number;
}

export default function TableHistory({ history, idProduct }: IProps) {
  const { t } = useTranslation();
  const { notificationControl } = useNotificationControl();
  const queryClient = useQueryClient();

  const ths = (
    <tr>
      <th>{t("meu_portfolio.meus_serviços.card_product.date_solicitation")}</th>
      <th>{t("meu_portfolio.meus_serviços.card_product.detail")}</th>
      <th>{t("meu_portfolio.meus_serviços.card_product.status_history")}</th>
      <th>{t("meu_portfolio.meus_serviços.card_product.effective_from")}</th>
      <th>{t("meu_portfolio.meus_serviços.card_product.cancel_history")}</th>
    </tr>
  );

  const { mutate: mutateCancel } = useMutation(postCancelHistoryPlans, {
    onSuccess: () => {
      queryClient.invalidateQueries(["MyHistoryPlans", idProduct]);
      queryClient.invalidateQueries(["MyProducts"]);
    },
    onError: () => {
      notificationControl({
        title: t("meu_portfolio.meus_serviços.card_product.error_title"),
        message: t("meu_portfolio.meus_serviços.card_product.error_message"),
        type: "danger",
      });
    },
  });

  const handleCancel = (value: number) => {
    mutateCancel({ id: idProduct, idHistory: value });
  };

  return (
    <Table>
      <thead>{ths}</thead>
      <tbody>
        {history?.data && history?.data?.length > 0 ? (
          history?.data.map((element, index) => {
            const statusInfo = colorStatusHistory(element.status); // Armazene o resultado aqui

            return (
              <tr key={`${element.id}-${index}`}>
                <td>{convertToDateAndHour(element.created_at)}</td>
                <td>{element.action_description}</td>
                <td>
                  <Flex align={"center"} gap="10px">
                    <TagStatus
                      status={statusInfo.color}
                      title={t(statusInfo.title)}
                      border
                    />
                    {element.status === EStatusHistory.Error ||
                    element.status === EStatusHistory.InProcessing ? (
                      <Tooltip label={element.error_message}>
                        <InfoCircle size="24" color="#F43333" variant="Bold" />
                      </Tooltip>
                    ) : null}
                  </Flex>
                </td>
                <td>{convertToDateAndHour(element.created_at)}</td>
                <td>
                  <Button
                    variant={"dangerOutline"}
                    disabled={!element.is_cancellable}
                    h="41px"
                    onClick={() => handleCancel(element.id)}
                  >
                    {t("global.button.cancel")}
                  </Button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td>----</td>
            <td>----</td>
            <td>----</td>
            <td>----</td>
            <td>----</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
